
<error-error-content 
  image="assets/img/images/error-images/image2.png"
  errorType="FORBIDDEN"
  copy="ERROR_403"></error-error-content>
